import React from "react";
import { Icon } from "@iconify/react";
import style from "../../../styles/landing.module.scss";

// Tarjeta (ítem de lista) con ícono, título (h3) y texto.
// El ícono es el objeto importado de @iconify/icons-mdi (funciona sin internet).
// styleGroup define la variante visual (ej. tarjeta_producto / tarjeta_servicio)
const TarjetaIconoComponent = ({ icono, titulo, texto, styleGroup = "" }) => {
    return (
        <li className={styleGroup}>
            <span className={style.tarjeta_icono} aria-hidden="true">
                <Icon icon={icono} />
            </span>
            <h3>{titulo}</h3>
            {texto && <p>{texto}</p>}
        </li>
    );
};

export default TarjetaIconoComponent;
